import InstagramIcon from '@/shared/icons/instagramIcon.svg';
import NaverBlogIcon from '@/shared/icons/naverBlogIcon.svg';
import ThreadIcon from '@/shared/icons/threadIcon.svg';
import YoutubeIcon from '@/shared/icons/youtubeIcon.svg';
import { cn } from '@/utils/style';
import { MagazineAuthorModel } from '@/views/magazine-author-detail/model/magazine';
import { Button } from 'doctornow-design-system';

interface Props {
  magazineAuthor?: MagazineAuthorModel | null;
  openSocialMediaLink: (type: 'instagram' | 'youtube' | 'thread' | 'naverBlog') => void;
  moveToAuthorHospital: () => void;
}
const MagazineAuthorInfo = ({ magazineAuthor, openSocialMediaLink, moveToAuthorHospital }: Props) => {
  if (!magazineAuthor) return null;

  return (
    <div className={cn(['flex flex-col gap-[15px] p-[32px_24px]', 'desktop:gap-[16px]'])}>
      <div className={cn('flex flex-col justify-between gap-[15px]', 'desktop:flex-row desktop:items-center')}>
        <div className={cn(['flex flex-col gap-[24px]', 'desktop:flex-row desktop:items-center'])}>
          <img
            alt='profile'
            className={'h-[80px] w-[80px] rounded-full border-[1px] border-gray-50 border-solid bg-white'}
            src={magazineAuthor.profileImage}
          />
          <div>
            <div className={'typography-ui-22b mb-[4px] text-gray-700'}>{magazineAuthor.getDisplayDoctorName()}</div>
            <div className={'typography-ui-15r whitespace-pre-line text-gray-700'}>
              {magazineAuthor.getProfileDescription()}
            </div>
          </div>
        </div>
        {magazineAuthor.isMagazineByDoctor() && (
          <div className={'flex flex-col'}>
            <Button onClick={moveToAuthorHospital}>병원 정보 보기</Button>
          </div>
        )}
      </div>

      {magazineAuthor.hasCareer() && (
        <div className={'flex flex-col gap-[4px] rounded-[8px] bg-gray-20 p-[20px]'}>
          {magazineAuthor.getDisplayCareer().map((career) => (
            <div key={career.id} className={'typography-ui-13r text-gray-400'}>
              {career.content}
            </div>
          ))}
        </div>
      )}
      {magazineAuthor.isMagazineByDoctornow() && (
        <div className={cn(['flex gap-[12px] *:min-h-[37px] *:min-w-fit *:cursor-pointer', 'desktop:justify-end'])}>
          <InstagramIcon onClick={() => openSocialMediaLink('instagram')} />
          <YoutubeIcon onClick={() => openSocialMediaLink('youtube')} />
          <ThreadIcon onClick={() => openSocialMediaLink('thread')} />
          <NaverBlogIcon onClick={() => openSocialMediaLink('naverBlog')} />
        </div>
      )}
    </div>
  );
};

export default MagazineAuthorInfo;
